import { render, staticRenderFns } from "./ResendPayslipModal.vue?vue&type=template&id=852d2276"
import script from "./ResendPayslipModal.vue?vue&type=script&lang=js"
export * from "./ResendPayslipModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports